import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterTimeline: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-timeline, sort"><path d="M3 16.25L6.0016 19.25L9 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 6.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 17.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 12H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.00195 4.75V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFilterTimeline;
